import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import FilterCollection from 'components/organisms/FilterCollection';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';

import { getHeadObj, makeRowColumn } from 'lib/commonLib';
import { browserStatistics, browserStatisticsGraph } from 'lib/api/browser';
import BrowserGraph from './BrowserGraph';

const Statistics = ({ location }) => {
  const { t } = useTranslation();
  const [initialization, setInitialization] = useState(false);

  const initParams = {
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    category: '01',
    pltfomTpCode: 'all',
  };

  const [params, setParams] = useState(initParams);
  const [customized, setCustomized] = useState({});

  useEffect(() => {
    handleCustomized(params);
    // eslint-disable-next-line
  }, []);

  const handleCustomized = (propsParmas) => {
    let customized = {
      STATS_HH: { merged: true },
      BROWSER_TP_CODE: { merged: true },
      OS_TP_CODE: { merged: true },
      DEVICE_TP_CODE: { merged: true },
      BROWSER_NAME: { merged: propsParmas.category !== '01' },
      OS_NAME: { merged: propsParmas.category !== '02' },
      DEVICE_NAME: { merged: propsParmas.category !== '03' },
      PAR_EPRS_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'PAR_EPRS_CNT').label}
              <br />
              {getHeadObj(headsMap, 'PAR_EPRS_CNT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const parEprsCnt = getHeadObj(headsMap, 'PAR_EPRS_CNT');
          const parEprsCntRate = getHeadObj(headsMap, 'PAR_EPRS_CNT_OCC_RATE');
          return (
            <>
              <b style={{ color: '#0072bc' }}>
                {makeRowColumn(
                  rowObj['PAR_EPRS_CNT'],
                  parEprsCnt.type,
                  parEprsCnt.format
                )}
              </b>
              {!!rowObj['PAR_EPRS_CNT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['PAR_EPRS_CNT_OCC_RATE'],
                    parEprsCntRate.type,
                    parEprsCntRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      PAR_EPRS_CNT_OCC_RATE: { merged: true },
      CLICK_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'CLICK_CNT').label}
              <br />
              {getHeadObj(headsMap, 'CLICK_RATE').label}
              <br />
              {getHeadObj(headsMap, 'CLICK_CNT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const clickCnt = getHeadObj(headsMap, 'CLICK_CNT');
          const clickRate = getHeadObj(headsMap, 'CLICK_RATE');
          const clickCntRate = getHeadObj(headsMap, 'CLICK_CNT_OCC_RATE');
          return (
            <>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                clickCnt.type,
                clickCnt.format
              )}
              {!!rowObj['CLICK_RATE'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['CLICK_RATE'],
                    clickRate.type,
                    clickRate.format
                  )})`}
                </>
              )}
              {!!rowObj['CLICK_CNT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['CLICK_CNT_OCC_RATE'],
                    clickCntRate.type,
                    clickCntRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      ADVRTS_AMT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'ADVRTS_AMT').label}
              <br />
              {getHeadObj(headsMap, 'TRGT_ADVRTS_AMT').label}
              <br />
              {getHeadObj(headsMap, 'ADVRTS_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
          const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
          const advrtsAmtRate = getHeadObj(headsMap, 'ADVRTS_AMT_OCC_RATE');
          return (
            <>
              {makeRowColumn(
                rowObj['ADVRTS_AMT'],
                advrtsAmt.type,
                advrtsAmt.format
              )}
              원
              {!!rowObj['TRGT_ADVRTS_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['TRGT_ADVRTS_AMT'],
                    trgtAdvrtsAmt.type,
                    trgtAdvrtsAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['ADVRTS_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['ADVRTS_AMT_OCC_RATE'],
                    advrtsAmtRate.type,
                    advrtsAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      PRDT_TRGT_OCC_RATE: {
        orderFlag: false,
      },
      ADVRTS_AMT_OCC_RATE: { merged: true },
      TRGT_ADVRTS_AMT: { merged: true },
      SESSION_ORDER_AMT: { merged: true },
      MOB_SESSION_ORDER_AMT: { merged: true },
      DIRECT_ORDER_AMT: { merged: true },
      ORDER_AMT: { merged: true },
      TRGT_ORDER_AMT: { merged: true },
      CLICK_RATE: { merged: true },
      RETRN_RATE: { merged: true },
      AVAL_RATE: { merged: true },
      CONV_RATE: { merged: true },
      RETRN_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'RETRN_CNT').label}
              <br />
              {getHeadObj(headsMap, 'RETRN_RATE').label}
              <br />
              {getHeadObj(headsMap, 'RETRN_CNT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const retrnCnt = getHeadObj(headsMap, 'RETRN_CNT');
          const retrnRate = getHeadObj(headsMap, 'RETRN_RATE');
          const retrnCntRate = getHeadObj(headsMap, 'RETRN_CNT_OCC_RATE');
          return (
            <>
              {makeRowColumn(
                rowObj['RETRN_CNT'],
                retrnCnt.type,
                retrnCnt.format
              )}
              {!!rowObj['RETRN_RATE'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['RETRN_RATE'],
                    retrnRate.type,
                    retrnRate.format
                  )})`}
                </>
              )}
              {!!rowObj['RETRN_CNT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['RETRN_CNT_OCC_RATE'],
                    retrnCntRate.type,
                    retrnCntRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      AVAL_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'AVAL_CNT').label}
              <br />
              {getHeadObj(headsMap, 'AVAL_RATE').label}
              <br />
              {getHeadObj(headsMap, 'AVAL_CNT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const avalCnt = getHeadObj(headsMap, 'AVAL_CNT');
          const avalRate = getHeadObj(headsMap, 'AVAL_RATE');
          const avalCntRate = getHeadObj(headsMap, 'AVAL_CNT_OCC_RATE');
          return (
            <>
              {makeRowColumn(rowObj['AVAL_CNT'], avalCnt.type, avalCnt.format)}
              {!!rowObj['AVAL_RATE'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['AVAL_RATE'],
                    avalRate.type,
                    avalRate.format
                  )})`}
                </>
              )}
              {!!rowObj['AVAL_CNT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['AVAL_CNT_OCC_RATE'],
                    avalCntRate.type,
                    avalCntRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      ORDER_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'ORDER_CNT').label}
              <br />
              {getHeadObj(headsMap, 'CONV_RATE').label}
              <br />
              {getHeadObj(headsMap, 'ORDER_CNT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const orderCnt = getHeadObj(headsMap, 'ORDER_CNT');
          const convRate = getHeadObj(headsMap, 'CONV_RATE');
          const orderCntRate = getHeadObj(headsMap, 'ORDER_CNT_OCC_RATE');
          return (
            <>
              {makeRowColumn(
                rowObj['ORDER_CNT'],
                orderCnt.type,
                orderCnt.format
              )}
              {!!rowObj['CONV_RATE'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['CONV_RATE'],
                    convRate.type,
                    convRate.format
                  )})`}
                </>
              )}
              {!!rowObj['ORDER_CNT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['ORDER_CNT_OCC_RATE'],
                    orderCntRate.type,
                    orderCntRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      MOB_SESSION_ROAS: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'MOB_SESSION_ROAS').label}
              <br />
              {getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT').label}
              <br />
              {getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
          const mobSessionOrderAmt = getHeadObj(
            headsMap,
            'MOB_SESSION_ORDER_AMT'
          );
          const mobSessionOrderAmtRate = getHeadObj(
            headsMap,
            'MOB_SESSION_ORDER_AMT_OCC_RATE'
          );
          return (
            <>
              {makeRowColumn(
                rowObj['MOB_SESSION_ROAS'],
                mobSessionRoas.type,
                mobSessionRoas.format
              )}
              {!!rowObj['MOB_SESSION_ORDER_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['MOB_SESSION_ORDER_AMT'],
                    mobSessionOrderAmt.type,
                    mobSessionOrderAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['MOB_SESSION_ORDER_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['MOB_SESSION_ORDER_AMT_OCC_RATE'],
                    mobSessionOrderAmtRate.type,
                    mobSessionOrderAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      SESSION_ROAS: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'SESSION_ROAS').label}
              <br />
              {getHeadObj(headsMap, 'SESSION_ORDER_AMT').label}
              <br />
              {getHeadObj(headsMap, 'SESSION_ORDER_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
          const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
          const sessionOrderAmtRate = getHeadObj(
            headsMap,
            'SESSION_ORDER_AMT_OCC_RATE'
          );
          return (
            <>
              {makeRowColumn(
                rowObj['SESSION_ROAS'],
                sessionRoas.type,
                sessionRoas.format
              )}
              {!!rowObj['SESSION_ORDER_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['SESSION_ORDER_AMT'],
                    sessionOrderAmt.type,
                    sessionOrderAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['SESSION_ORDER_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['SESSION_ORDER_AMT_OCC_RATE'],
                    sessionOrderAmtRate.type,
                    sessionOrderAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      DIRECT_ROAS: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'DIRECT_ROAS').label}
              <br />
              {getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label}
              <br />
              {getHeadObj(headsMap, 'DIRECT_ORDER_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
          const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
          const directOrderAmtRate = getHeadObj(
            headsMap,
            'DIRECT_ORDER_AMT_OCC_RATE'
          );
          return (
            <>
              {makeRowColumn(
                rowObj['DIRECT_ROAS'],
                directRoas.type,
                directRoas.format
              )}
              {!!rowObj['DIRECT_ORDER_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['DIRECT_ORDER_AMT'],
                    directOrderAmt.type,
                    directOrderAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['DIRECT_ORDER_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['DIRECT_ORDER_AMT_OCC_RATE'],
                    directOrderAmtRate.type,
                    directOrderAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      ROAS: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'ROAS').label}
              <br />
              {getHeadObj(headsMap, 'ORDER_AMT').label}
              <br />
              {getHeadObj(headsMap, 'ORDER_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const roas = getHeadObj(headsMap, 'ROAS');
          const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
          const orderAmtRate = getHeadObj(headsMap, 'ORDER_AMT_OCC_RATE');
          return (
            <>
              {makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
              {!!rowObj['ORDER_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['ORDER_AMT'],
                    orderAmt.type,
                    orderAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['ORDER_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['ORDER_AMT_OCC_RATE'],
                    orderAmtRate.type,
                    orderAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      TRGT_ROAS: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'TRGT_ROAS').label}
              <br />
              {getHeadObj(headsMap, 'TRGT_ORDER_AMT').label}
              <br />
              {getHeadObj(headsMap, 'TRGT_ORDER_AMT_OCC_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
          const trgtorderAmt = getHeadObj(headsMap, 'TRGT_ORDER_AMT');
          const trgtorderAmtRate = getHeadObj(
            headsMap,
            'TRGT_ORDER_AMT_OCC_RATE'
          );
          return (
            <>
              {makeRowColumn(
                rowObj['TRGT_ROAS'],
                trgtRoas.type,
                trgtRoas.format
              )}
              {!!rowObj['TRGT_ORDER_AMT'] && (
                <>
                  <br />
                  {`(${makeRowColumn(
                    rowObj['TRGT_ORDER_AMT'],
                    trgtorderAmt.type,
                    trgtorderAmt.format
                  )}원)`}
                </>
              )}
              {!!rowObj['TRGT_ORDER_AMT_OCC_RATE'] && (
                <>
                  <br />
                  {`[${makeRowColumn(
                    rowObj['TRGT_ORDER_AMT_OCC_RATE'],
                    trgtorderAmtRate.type,
                    trgtorderAmtRate.format
                  )}]`}
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      CLICK_CNT_OCC_RATE: { merged: true },
      RETRN_CNT_OCC_RATE: { merged: true },
      AVAL_CNT_OCC_RATE: { merged: true },
      ORDER_CNT_OCC_RATE: { merged: true },
      MOB_SESSION_ORDER_AMT_OCC_RATE: { merged: true },
      SESSION_ORDER_AMT_OCC_RATE: { merged: true },
      DIRECT_ORDER_AMT_OCC_RATE: { merged: true },
      ORDER_AMT_OCC_RATE: { merged: true },
      TRGT_ORDER_AMT_OCC_RATE: { merged: true },
    };
    setCustomized(customized);
  };

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      handleCustomized(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={true}
          useExternalFilter={false}
          usePltfomTpCodeFilter={true}
          onlyProducts={true}
          onlyTargeting={false}
        />
        <FilterCollection
          label={t('사용자구분')}
          name="category"
          params={params}
          value={params.category}
          type="radio"
          list={[
            { label: t('Browser별'), value: '01' },
            { label: t('OS별'), value: '02' },
            { label: t('Device별'), value: '03' },
          ]}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>
      <BrowserGraph params={params} dataReqPromise={browserStatisticsGraph} />
      <NewTableContainer
        params={params}
        dataReqPromise={browserStatistics}
        getParam={getParam}
        isIncludingTotal
        useFetch={false}
        useTotal={true}
        rowsPerPage={-1}
        useSearch={false}
        useExcel={false}
        customized={customized}
      />
    </>
  );
};

export default withRouter(Statistics);
